const mockAppointments = [
    {
        id: 1,
        student_number: '2003923',
        student_name: 'Selen',
        student_surname: 'Aytaş',
        faculty: 'Mühendislik ve Doğa Bilimleri Fakültesi',
        department: 'Bilgisayar Mühendisliği',
        program: 'Bilgisayar Mühendisliği (İngilizce)',
        student_group: 'A Grubu',
        counselor_name: 'Barış Taçyıldız',
        appointment_date: '25.12.2025',
        appointment_time: '17:00',
        status: 'Bekliyor'
    },
    {
        id: 2,
        student_number: '2004561',
        student_name: 'Ahmet',
        student_surname: 'Yılmaz',
        faculty: 'İktisadi, İdari ve Sosyal Bilimler Fakültesi',
        department: 'İşletme',
        program: 'İşletme (Türkçe)',
        student_group: 'B Grubu',
        counselor_name: 'Ayşe Yılmaz',
        appointment_date: '26.12.2025',
        appointment_time: '10:00',
        status: 'Onaylandı'
    },
    {
        id: 3,
        student_number: '2007890',
        student_name: 'Elif',
        student_surname: 'Kaya',
        faculty: 'Mühendislik ve Doğa Bilimleri Fakültesi',
        department: 'Yazılım Mühendisliği',
        program: 'Yazılım Mühendisliği (İngilizce)',
        student_group: 'A Grubu',
        counselor_name: 'Ahmet Demir',
        appointment_date: '27.12.2025',
        appointment_time: '14:00',
        status: 'Reddedildi'
    }
];

const mockCounselors = [
    "Barış Taçyıldız",
    "Ayşe Yılmaz",
    "Ahmet Demir",
    "Elif Kaya"
];

const mockTimes = [
    "09:00",
    "10:00",
    "11:00",
    "12:00",
    "13:00",
    "14:00",
    "15:00",
    "16:00",
    "17:00"
];

let mockCalendarConfig = {
    active_days: ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma'],
    active_hours: ["09:00", "10:00", "11:00", "13:00", "14:00", "15:00", "16:00", "17:00"]
};

const getAll = async (config) => {
    let rows = [...mockAppointments];
    const filter = config?.params?.filter ?? {};

    if (filter.student_number) {
        rows = rows.filter(row => row.student_number.includes(filter.student_number));
    }
    if (filter.student_name) {
        rows = rows.filter(row => row.student_name.toLowerCase().includes(filter.student_name.toLowerCase()));
    }
    if (filter.student_surname) {
        rows = rows.filter(row => row.student_surname.toLowerCase().includes(filter.student_surname.toLowerCase()));
    }
    if (filter.faculty) {
        rows = rows.filter(row => row.faculty.toLowerCase().includes(filter.faculty.toLowerCase()));
    }
    if (filter.department) {
        rows = rows.filter(row => row.department.toLowerCase().includes(filter.department.toLowerCase()));
    }
    if (filter.program) {
        rows = rows.filter(row => row.program.toLowerCase().includes(filter.program.toLowerCase()));
    }
    if (filter.student_group) {
        rows = rows.filter(row => row.student_group.toLowerCase().includes(filter.student_group.toLowerCase()));
    }
    if (filter.status) {
        rows = rows.filter(row => row.status === filter.status);
    }

    return Promise.resolve({
        data: {
            data: rows,
            pagination: {
                total: rows.length
            }
        }
    });
};

const create = async (formData) => {
    const newApp = {
        id: mockAppointments.length ? Math.max(...mockAppointments.map(a => a.id)) + 1 : 1,
        student_number: formData.student_number || '2003923',
        student_name: formData.student_name || 'Selen',
        student_surname: formData.student_surname || 'Aytaş',
        faculty: formData.faculty || 'Mühendislik ve Doğa Bilimleri Fakültesi',
        department: formData.department || 'Bilgisayar Mühendisliği',
        program: formData.program || 'Bilgisayar Mühendisliği (İngilizce)',
        student_group: formData.student_group || 'A Grubu',
        counselor_name: formData.counselor_name,
        appointment_date: formData.appointment_date,
        appointment_time: formData.appointment_time,
        status: 'Bekliyor'
    };
    mockAppointments.push(newApp);
    return Promise.resolve({ data: { message: 'success', data: newApp } });
};

const remove = async (id) => {
    const index = mockAppointments.findIndex((item) => item.id === Number(id));
    if (index !== -1) {
        mockAppointments.splice(index, 1);
    }
    return Promise.resolve({ data: { message: 'success' } });
};

const updateStatus = async (id, status) => {
    const row = mockAppointments.find(item => item.id === Number(id));
    if (row) {
        row.status = status;
    }
    return Promise.resolve({ data: { message: 'success' } });
};

const getCalendarConfig = async () => {
    return Promise.resolve({ data: mockCalendarConfig });
};

const saveCalendarConfig = async (config) => {
    mockCalendarConfig = { ...config };
    return Promise.resolve({ data: { message: 'success' } });
};

const getCounselors = async () => {
    return Promise.resolve({ data: mockCounselors });
};

const getAvailableTimes = async () => {
    return Promise.resolve({ data: mockTimes });
};

const reschedule = async (id, date, time) => {
    const row = mockAppointments.find(item => item.id === Number(id));
    if (row) {
        row.appointment_date = date;
        row.appointment_time = time;
    }
    return Promise.resolve({ data: { message: 'success' } });
};

export default {
    getAll,
    create,
    remove,
    updateStatus,
    reschedule,
    getCalendarConfig,
    saveCalendarConfig,
    getCounselors,
    getAvailableTimes
};
